"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldInitialReferenceStep = void 0;
const type_1 = require("../../../type");
const FieldInitialReferenceStep = (props) => {
    var _a;
    let initialValue = {};
    (_a = props.fields) === null || _a === void 0 ? void 0 : _a.filter((s) => {
        return !s.childKey;
    }).forEach((k) => {
        initialValue[k.name] = "";
    });
    if (props.grandParentKey === props.parentKey) {
        if (props.childType === type_1.TYPE_ARRAY) {
            // console.log("INIT 1.1", initialValue);
            props.FieldReference.current[props.parentIndex] = {
                [props.parentKey]: [initialValue],
            };
        }
        else {
            // console.log("INIT 1.2", initialValue);
            props.FieldReference.current[props.parentIndex] = {
                [props.parentKey]: initialValue,
            };
        }
    }
    else if (props.grandParentKey !== props.parentKey &&
        props.grandParentIndex >= 0 &&
        props.parentIndex >= 0 &&
        props.FieldReference.current[props.grandParentIndex]) {
        if (props.childType === type_1.TYPE_ARRAY) {
            // console.log("INIT 2.1", initialValue);
            props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex]), { [props.parentKey]: [initialValue] });
        }
        else {
            // console.log("INIT 2.2", initialValue);
            props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex]), { [props.parentKey]: initialValue });
        }
    }
    else if (props.grandParentKey !== props.parentKey &&
        props.grandParentIndex >= 0 &&
        props.FieldReference.current[props.grandParentIndex]) {
        if (props.childType === type_1.TYPE_ARRAY) {
            // console.log("INIT 3.1", {
            //   initialValue,
            //   check:
            //     props.FieldReference.current[props.grandParentIndex][
            //       props.grandParentKey
            //     ],
            // });
            props.FieldReference.current[props.grandParentIndex][props.grandParentKey] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentKey]: [initialValue] });
        }
        else {
            // console.log("INIT 3.2", initialValue);
            props.FieldReference.current[props.grandParentIndex][props.grandParentKey] = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentKey]: initialValue });
        }
    }
    return;
};
exports.FieldInitialReferenceStep = FieldInitialReferenceStep;
